<script>
import Medium from "../Components/Medium.svelte";
import { fade } from 'svelte/transition';
import { GetContact, PostContact } from "../Services/form0";
import { user } from "../store";
import { loading } from "../loader";
import { options } from "../config";
import { onMount } from "svelte";

import { message_ } from "../Services/messages";
import LoggedIn from "../Components/Auth/LoggedIn.svelte";
 
export let params = {}

var data = {
    form:"internal/compliance/checklist",
    profile:options.profile,
    data:{
       assets:[{}] 
    }
    
}

const macuser=()=>{
    data.data.macuser=true
    data.data.winuser=false
}
const winuser=()=>{
    data.data.winuser=true
    data.data.macuser=false
}

const add_asset = ()=>{
    data.data.assets = [...data.data.assets,{}]
    console.log("Click")
}

const save=()=>{
    loading.set(true)
    PostContact(data,$user.idToken,(result)=>{
        loading.set(false)
    },(error=>{
        message_.set("Broken result")
        loading.set(false)
    }))
}

onMount(()=>{
    
    if(params.wild){
        loading.set(true)
        GetContact(options.profile,params.wild,$user.idToken,(d)=>{
            loading.set(false)
            if(d)
                data=d
            else
                message_.set("Not a valid path")
            data.form="internal/compliance/checklist"
            data.profile=options.profile
        },(error)=>{
            message_.set("Broken link")
            loading.set(false)
        })
    }
})

</script>
<LoggedIn/>
{#if $user.loggedIn}
<div class="section_wrapper">
    <div class="s s100 gap">
         <div class="s s100 box ">
             <div class="content_area">
                <h1>Are you a MAC user?</h1>
             
                    <a class="linkbox green"  on:click={()=>macuser()}>Yes</a>
                    <a class="linkbox green"  on:click={()=>winuser()}>No</a>
               
                
                {#if data.data.macuser}
                <p transition:fade>You are a MAC user. I Feel for you</p>
                {/if}
                {#if data.data.winuser}
                <p transition:fade>You are a PC user. Well done!</p>
                {/if}
             </div>
            
         </div>
    </div>

    {#if data.data.macuser}
        <div class="s s100 gap" transition:fade>
            <div class="s s100 box">
                <div class="content_area">
                    <h1>Install ESET</h1>
                    <p>ESET is the selected anti virus software for MAC Users at base2. Contact Lewis for an installation file</p>
                    <Medium  bind:data={data.data.cylance} name="cylance" placeholder="Screen capture ESET working on your MAC and paste it in here using copy/paste or dragging a file"/>
                </div>
            </div>
        </div>
        <div class="s s100 gap" transition:fade>
            <div class="s s100 box">
                <div class="content_area">
                    <h1>Activate FileVault2</h1>
                    <p>FileVault2 is a disc encryption software standard with all MACS. <a href="https://support.apple.com/en-us/HT204837" target="_blank">Follow the steps here to activate it</a></p>
                    <Medium  bind:data={data.data.filevault2} name="filevault" placeholder="Screen capture FileVault2 Settings on your MAC and paste it in here using copy/paste or dragging a file"/>
                </div>
            </div>
        </div>
    {/if}
    {#if data.data.winuser}
        <div class="s s100 gap" transition:fade>
            <div class="s s100 box">
                <div class="content_area">
                    <h1>Install ESET</h1>
                    <p>ESET is the selected anti virus software for Windows Users at base2. Contact Lewis for an installation file</p>
                    
                    <Medium  bind:data={data.data.wav} name="wav" placeholder="Screen capture ESET working on your PC and paste it in here using copy/paste or dragging a file"/>
                </div>
            </div>
        </div>
        <div class="s s100 gap" transition:fade>
            <div class="s s100 box">
                <div class="content_area">
                    <h1>Activate Bitlocker</h1>
                    <p>Bitlocker is the selected encryption software for PC Users at base2.</p>
                    <p>Hint: use this <a href="ms-settings:deviceencryption">link</a> and then go to Bitlocker settings</p>
                    <Medium  bind:data={data.data.bitlocker} name="bitlocker" placeholder="Screen capture Bitlocker from System and Security working on your PC and paste it in here using copy/paste or dragging a file"/>
                    <h2>Backup and upload your recovery key</h2>
                    <p>In your "Control Panel\System and Security\BitLocker Drive Encryption" location select Backup your recovery key, Save to File. Save it to a USB drive as you will not be able to save it to the drive you want to encrypt</p>
                    <textarea bind:value={data.data.bitlocker_recovery} placeholder="Paste the contents of your recovery key file in here"/>
                </div>
            </div>
        </div>
    {/if}

    {#if data.data.winuser||data.data.macuser}

    <div class="s s100 gap" transition:fade>
        <div class="s s100 box">
            <div class="content_area">
                <h1>Setup and Use Quad9</h1>
                <p>Quad9 is for your DNS settings. Setup guides can be found at <a href="https://www.quad9.net/support/set-up-guides" target="_blank">https://www.quad9.net/support/set-up-guides</a></p>
                <Medium  bind:data={data.data.quad9} name="quad9" placeholder="Screen capture QUAD9 working on your MAC or PC and paste it in here using copy/paste or dragging a file"/>
            </div>
        </div>
    </div>

    <div class="s s100 gap" transition:fade>
        <div class="s s100 box">
            <div class="content_area">
                <h1>Policies and Procedures</h1>
                <p>Reading the Policies and Procedures is a critical part of ensuring that we all understand what we need to do in the case of a breach and to ensure we all understand the security guidelines we need to follow</p>
                <p>The documents can be read from this location <a href="https://base2-devops.atlassian.net/wiki/spaces/CP/overview" target="_blank">Open Document Location</a></p>
                <hr/>
                <p >Please complete the <a style="font-weight: 900; font-size:50px" href="https://forms.gle/YXkvPS79tukK8dqF9" target="_blank" >*** QUIZ ***</a> to confirm your knowledge and understanding.  If your score is too low you may be asked to complete a supplementary quiz.</p>
                <input id="policies" type="checkbox" bind:checked={data.data.procedures} class="styled"/>
                <label for="policies"> Check this box when you have completed the Quiz</label>

                
                
            </div>
        </div>
    </div>

    <div class="s s100 gap" transition:fade>
        <div class="s s100 box">
            <div class="content_area">
                <h1>Asset Register</h1>
                <p>The Asset Register is designed to ensure that base2 assets have a known owner. Enter the information below to update the asset register</p>
                {#if data.data.winuser}
                <p>Hint: Use this <a href="ms-settings:about">link</a> and then copy your device id enter into the Serial Number</p>
                {/if}
                <table class="form_table">
                    <thead>
                        <tr>
                            <th>Serial Number</th>
                            <th>Description</th>
                            <th>Location</th>
                            <th>Owner</th>
                            <th></th>
                            <th>Sticker</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each data.data.assets as t,i}
                        <tr>
                            <td>
                                <input type="text" bind:value={t.serial_number}>
                            </td>
                            <td>
                                <input type="text" bind:value={t.description}>
                            </td>
                            <td>
                                <select bind:value={t.location}>
                                    <option value="Melbourne">Melbourne</option>
                                    <option value="Brazil">Brazil</option>
                                    <option value="South Africa">South Africa</option>
                                    <option value="Canada">Canada</option>
                                    <option value="Vietname">Vietnam</option>
                                    <option value="Berlin">Berlin</option>
                                    <option value="Austin">Austin</option>
                                </select>
                            </td>
                            <td>
                                <input type="radio"  id="owner{i}" checked class="styled" bind:group={t.owner} value={"base2Services"}>
                                <label for="owner{i}">Owned by base2Services</label>
                            </td>
                            <td>
                                <input type="radio"  id="owner2_{i}"  class="styled" bind:group={t.owner} value={"member"}>
                                <label for="owner2_{i}">I own the asset</label>
                            </td>
                            <td>
                                <input type="text" bind:value={t.sticker}>
                            </td>
                        </tr>
                        {/each}
                    </tbody>
                </table>
                <a class="linkbox green" on:click={()=>add_asset()}>Add asset line</a>
            </div>
        </div>
    </div>

    <div class="s s100">
        <div class="s s100 box">
            <div class="content_area  text_right">
                <a class="linkbox green" on:click={()=>save()}>Save</a>
            </div>
        </div>
    </div>
    {/if}
</div>
{/if}